/**
 * Custom theme overrides — safe from theme updates.
 *
 * Quick buy (product-card quick add + quick-buy drawer/modal) must always add
 * to cart via ajax, even when the theme cart setting is "page". The theme's
 * ProductForm submit handler (assets/theme.js) redirects to /cart whenever
 * cartType === "page", so we temporarily mask that setting for the duration
 * of a quick-buy submit and restore it once the cart has updated (or errored).
 */
(function () {
  var QUICK_BUY_SELECTOR = 'quick-buy-drawer, #quick-buy-modal-content, .product-card__quick-buy';

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.closest || !form.closest(QUICK_BUY_SELECTOR)) {
        return;
      }

      var settings = window.themeVariables && window.themeVariables.settings;
      if (!settings || settings.cartType !== 'page') {
        return;
      }

      var restored = false;
      var restore = function () {
        if (restored) {
          return;
        }
        restored = true;
        settings.cartType = 'page';
        document.documentElement.removeEventListener('cart:change', restore);
        form.removeEventListener('cart:error', restore);
      };

      // "none" is not a real cart type, so neither the redirect ("page"),
      // the cart drawer, nor the popover will trigger; the quick-buy drawer
      // shows its own confirmation via the variant:add event.
      settings.cartType = 'none';
      document.documentElement.addEventListener('cart:change', restore);
      form.addEventListener('cart:error', restore);
      setTimeout(restore, 10000);
    },
    true
  );
})();
